import { List } from '@mui/material';
import { HiOutlineBanknotes } from 'react-icons/hi2';
import {
  LuArrowUpNarrowWide,
  LuBuilding,
  LuClock,
  LuGraduationCap,
  LuMap,
  LuMapPin,
  LuNavigation,
  LuPlane,
  LuStamp,
  LuUser,
} from 'react-icons/lu';
import { TbBriefcase } from 'react-icons/tb';
import { ControlledTextInput, WsColors, WsSelect } from 'wisestep-base';

import CheckboxListFilter from '../../../../components/filters/components/CheckboxListFilter';
import JobTitleFilter from '../../../../components/filters/components/JobTitleFilter';
import WsAccordion from '../../../../components/filters/components/WsAccordion';
import {
  powerCitizenShipCheckBoxOptions,
  powerCareerLevelOptions,
  powerGlobalSecurityCheckBoxOptions,
  powerMinimumEducationLevelOptions,
  powerRelocationOptions,
  powerTargetJobTypeOptions,
  powerWillingTravelOptions,
  powerWorkAuthorizationOptions,
  powerYearlySalaryOptions,
} from '../utils/MonsterHelper';

import SelectFilters from './SelectFilter';

const PowerSearchAdvanceFilter = () => (
  <List>
    <JobTitleFilter
      name="companyName"
      placeHolder="Company Name"
      title="Company Name"
      icon={<LuBuilding color={WsColors.TertiaryShades800} />}
    />
    <WsAccordion title={'Candidate Name'} startIcon={<LuUser color={WsColors.TertiaryShades800} />}>
      <ControlledTextInput
        name="candidateName"
        placeholder="Search with candidate Name"
        title="Candidate Name"
        fullWidth={true}
      />
    </WsAccordion>
    <JobTitleFilter
      name="schoolName"
      placeHolder="Recent school name"
      title="Recent School Name"
      icon={<LuGraduationCap color={WsColors.TertiaryShades800} />}
    />
    <JobTitleFilter
      name="educationMajor"
      placeHolder="Search With Education Major"
      title="Education Major"
      icon={<LuGraduationCap color={WsColors.TertiaryShades800} />}
    />
    <SelectFilters
      name="targetJobTypeId"
      title="Target Job Type"
      selectArray={powerTargetJobTypeOptions}
      startIcon={<TbBriefcase color={WsColors.TertiaryShades800} />}
    />
    <WsAccordion title={'Job Tenure'} startIcon={<LuClock color={WsColors.TertiaryShades800} />}>
      <ControlledTextInput
        name="jobTenure"
        placeholder="(e.g 4, 2-3, 5+, <8)"
        title="Job Tenure"
        fullWidth={true}
      />
    </WsAccordion>
    <SelectFilters
      name="minimumEducationLevel"
      title="Education level"
      selectArray={powerMinimumEducationLevelOptions}
      startIcon={<LuGraduationCap color={WsColors.TertiaryShades800} />}
    />
    <SelectFilters
      name="relocation"
      title="Willing to Relocate"
      selectArray={powerRelocationOptions}
      startIcon={<LuMap color={WsColors.TertiaryShades800} />}
    />
    <SelectFilters
      name="willingnessToTravel"
      title="willing To Travel"
      selectArray={powerWillingTravelOptions}
      startIcon={<LuNavigation color={WsColors.TertiaryShades800} />}
    />
    <CheckboxListFilter
      name="legalStatusArr"
      options={powerCitizenShipCheckBoxOptions}
      title="Citizen Ship"
      startIcon={<LuMapPin color={WsColors.TertiaryShades800} />}
    />
    <WsAccordion
      title="Work authorization"
      startIcon={<LuPlane color={WsColors.TertiaryShades800} />}
    >
      <WsSelect name="wa" selectArray={powerWorkAuthorizationOptions} placeholder="Select" />
    </WsAccordion>

    <SelectFilters
      name="careerLevelId"
      title="Career Level"
      selectArray={powerCareerLevelOptions}
      startIcon={<LuArrowUpNarrowWide color={WsColors.TertiaryShades800} />}
    />

    <SelectFilters
      name="tsalmax"
      title="Yearly Salary"
      selectArray={powerYearlySalaryOptions}
      startIcon={<HiOutlineBanknotes color={WsColors.TertiaryShades800} />}
    />
    <WsAccordion
      title={'Years of Experience'}
      startIcon={<LuClock color={WsColors.TertiaryShades800} />}
    >
      <ControlledTextInput
        name="experience"
        placeholder="(e.g., 4, 2-3, 5+, <8)"
        title="Years of Experience"
        fullWidth={true}
      />
    </WsAccordion>

    <CheckboxListFilter
      name="pgscArr"
      options={powerGlobalSecurityCheckBoxOptions}
      title="Global Security Clearance"
      startIcon={<LuStamp color={WsColors.TertiaryShades800} />}
    />
  </List>
);

export default PowerSearchAdvanceFilter;
